import { connect } from "react-redux";
import Overview from "./Overview";
import {
  getProgramDetails,
  deleteProgramsRequest,
  updateProgramsRequest,
  ProgramStatusReportRequest,
  ProgramClearReportRequest,
} from "../../../store/actions/programs.actions";
import {
  overviewLoader,
  program,
  programBudgetSummary as budgetSummary,
  programProgressSummary as progressSummary,
  programLoading,
  programReport,
  programReportLoading
} from "../../../store/selectors/programs.selector";

const mapDispatchToProps = {
  getProgramDetails,
  deleteProgramsRequest,
  updateProgramsRequest,
  ProgramStatusReportRequest,
  ProgramClearReportRequest
};

const mapStateToProps = (state) => {
  const programData = program(state);
  const programBudgetSummary = budgetSummary(state);
  const programProgressSummary = progressSummary(state);
  const loading = programLoading(state);
  const programOverviewLoading = overviewLoader(state);
  const getProgramReport = programReport(state);
  const getProgramReportLoading = programReportLoading(state);
  return {
    programData,
    programBudgetSummary,
    programProgressSummary,
    loading,
    programOverviewLoading,
    getProgramReport,
    getProgramReportLoading
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
